import request from '@/util/request';

/**
 * 登录
 * @param {phone,uuid,password} data
 */
export function employeeLogin(data, uuid) {
    return request({
        url: `/api/v1/account/employee/captcha/login?bid=${uuid}`,
        method: 'POST',
        data,
    })
}
/**
 * 获得用户登录详情
 * @param {*jobNumber} data
 */
export function employeeRefresh(pramas) {
    return request({
        url: `/api/v1/account/employee/refresh`,
        method: 'POST',
        pramas,
    })
}


/**
 * 手机检测(获取企业编号)
 */
export function employeeAccount(data) {
    return request({
        url: `/api/v1/account/enterprise/check?phone=${data}`,
        method: 'POST',
    })
}


/**
 * 获取用于重置密码的操作码
 */
export function getChangeCode(data) {
    return request({
        url: `/api/v1/account/employee/forgetPasswordCode?phone=${data.phone}&code=${data.code}&bid=${data.uuid}`,
        method: 'POST',
    })
}

/**
 * 重置密码
 */
export function resetPassword(data, uuid) {
    return request({
        url: `/api/v1/account/employee/restPassword?bid=${uuid}`,
        method: 'POST',
        data,
    })
}


export function logout() {
    return new Promise(function (resolve) {
        resolve()
    })
}

export function changeEnterprise(uuid) {
    return request({
        url: `/api/v1/account/employee/changeEnterprise`,
        method: 'get',
        params: {uuid},
    })
}

export function employeeEdit(data) {
    return request({
        url: `/api/v1/account/employee/edit`,
        method: 'post',
        data
    })
}


export function employeeDelete(params) {
    return request({
        url: `/api/v1/account/employee/delete`,
        method: 'get',
        params
    })
}

export function employeeDepartmentIn(params) {
    return request({
        url: `/api/v1/account/employee/department/in`,
        method: 'get',
        params
    })
}

export function employeeCanAllocateDepartment() {
    return request({
        url: `/api/v1/account/employee/canAllocateDepartment`,
        method: 'get',
    })
}

export function employeeAllocateDepartment(data) {
    return request({
        url: `/api/v1/account/employee/allocateDepartment`,
        method: 'post',
        data
    })
}

export function employeeModules() {
    return request({
        url: `api/v1/account/employee/modules`,
        method: 'get',
    })
}

export function employeeCaptcha() {
  return request({
    url: `api/v1/account/employee/captcha`,
    method: 'get',
  })
}



